import CookiePolicy from '#app/components/cookiePolicy/cookiePolicy.tsx'

export default function cookiePolicyPage() {
	return <CookiePolicy />
}
